import React from 'react';
import { Grid2, Typography, Box } from '@mui/material';
import { AddonCard, Loader } from 'components';
import { InsuranceOption } from 'types/Insurance';
import { RentalRate } from 'types/BookingDetails';
import { getChargeCodes } from 'utils/localStorage';
import { useUserSearchContext } from 'context/UserSearchContext';
import { config } from 'config/config';
interface InsuranceCardProps {
  insuranceData?: RentalRate[] | null;
  onSelect?: (ChargeCode: string, chargeCodeType: number) => void;
}

export const InsuranceCard: React.FC<InsuranceCardProps> = ({
  insuranceData,
  onSelect,
}) => {
  const { bookingSearchData, loading } = useUserSearchContext();

  if (loading) return <Loader />;

  return (
    <Box className="box-container-layout">
      <Typography
        color="primary"
        sx={{ textAlign: 'start', marginBottom: '20px', fontWeight: 'normal' }}
      >
        Choose your{' '}
        <span style={{ textDecoration: 'underline', fontWeight: '600' }}>
          Protection
        </span>
      </Typography>
      <Grid2 container spacing={2}>
        {bookingSearchData.RentalRate &&
          bookingSearchData.RentalRate.map(
            (insurance, index) =>
              config.insuranceChargeCode.includes(insurance.Code) && (
                <Grid2 size={{ sm: 6 }} key={index}>
                  <AddonCard
                    id={insurance.Code}
                    title={insurance.Name}
                    description={insurance.Description}
                    price={insurance.TotalAmt}
                    numberOfDays={insurance.Duration}
                    isChecked={insurance.IsSelected}
                    onCheck={() => onSelect && onSelect(insurance.Code, 0)}
                    isCompulsoryOnRental={insurance.IsCompulsory}
                  />
                </Grid2>
              )
          )}
      </Grid2>
    </Box>
  );
};
